export default __webpack_public_path__ + "static/media/Tunic of Vindictive Malice.e0e4657a.jpg";